import gql from 'graphql-tag'

export const GET_ORGANIZATION_ITEM_CATEGORIES = gql`
  query GetOrganizationItemCategories(
    $organizationSlug: String
    $organizationId: ID
    $pagination: Pagination
  ) {
    getOrganizationItemCategories(
      organizationSlug: $organizationSlug
      organizationId: $organizationId
      pagination: $pagination
    )
  }
`

export const CREATE_ORGANIZATION_ITEM_CATEGORY = gql`
  mutation CreateOrganizationItemCategory(
    $organizationSlug: String
    $organizationId: ID
    $name: String!
    $color: String!
    $priority: Float!
    $displayIfSoldOut: Boolean
    $description: String
  ) {
    createOrganizationItemCategory(
      organizationSlug: $organizationSlug
      organizationId: $organizationId
      name: $name
      color: $color
      priority: $priority
      displayIfSoldOut: $displayIfSoldOut
      description: $description
    ) {
      id
      name
      color
      priority
      displayIfSoldOut
      description
      organizationId
    }
  }
`
export const UPDATE_ORGANIZATION_ITEM_CATEGORY_BY_ID = gql`
  mutation UpdateOrganizationItemCategoryById(
    $organizationSlug: String
    $organizationId: ID
    $id: ID!
    $name: String!
    $color: String!
    $priority: Float!
    $description: String
    $displayIfSoldOut: Boolean
  ) {
    updateOrganizationItemCategoryById(
      organizationSlug: $organizationSlug
      organizationId: $organizationId
      id: $id
      name: $name
      color: $color
      priority: $priority
      description: $description
      displayIfSoldOut: $displayIfSoldOut
    )
  }
`
export const DELETE_ORGANIZATION_ITEM_CATEGORY = gql`
  mutation DeleteOrganizationItemCategoryById(
    $organizationSlug: String
    $organizationId: ID
    $id: ID!
  ) {
    deleteOrganizationItemCategoryById(
      organizationSlug: $organizationSlug
      organizationId: $organizationId
      id: $id
    )
  }
`
